import axios from 'axios'
import VueCookies from 'vue-cookies'

export default {
  get (data) {
    const limit = data.limit ? '&limit=' + data.limit : ''
    const page = data.page ? data.page : 1
    const clientId = data.client_id ? '&client_id=' + data.client_id : ''
    const dateFrom = data.date_from ? '&date_from=' + data.date_from : ''
    const dateTo = data.date_to ? '&date_to=' + data.date_to : ''
    return axios.get(process.env.API_ENDPOINT + '/quote?token=' + VueCookies.get('token') + '&page=' + page + limit + clientId + dateFrom + dateTo)
  },
  create (data) {
    return axios.post(process.env.API_ENDPOINT + '/quote?token=' + VueCookies.get('token'), data)
  },
  show (id) {
    return axios.get(process.env.API_ENDPOINT + '/quote/' + id + '?token=' + VueCookies.get('token'))
  },
  update (data, id) {
    return axios.put(process.env.API_ENDPOINT + '/quote/' + id + '?token=' + VueCookies.get('token'), data)
  },
  delete (id) {
    return axios.delete(process.env.API_ENDPOINT + '/quote/' + id + '?token=' + VueCookies.get('token'))
  }
}



// WEBPACK FOOTER //
// ./src/store/api/quotes.js